// language=GraphQL
export const ALL_AGE_FILTERS_QUERY = `query Query {
  ageFilters: travelPricingAgeFilters {
    id
    minAge
    maxAge
  }
}`

// language=GraphQL
export const SINGLE_AGE_FILTER_QUERY = `query Query($id: ID!) {
  ageFilter: travelPricingAgeFilter(id: $id) {
    id
    minAge
    maxAge
  }
}`

// language=GraphQL
export const CREATE_AGE_FILTER_MUTATION = `
  mutation Mutation($input: CreateTravelPricingAgeFilterInput) {
    ageFilter: createTravelPricingAgeFilter(input: $input) {
      id
      minAge
      maxAge
    }
  }`

// language=GraphQL
export const UPDATE_AGE_FILTER_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingAgeFilterInput) {
    ageFilter: updateTravelPricingAgeFilter(input: $input) {
      id
      minAge
      maxAge
    }
  }`

// language=GraphQL
export const DELETE_AGE_FILTER_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingAgeFilterInput) {
    deleteTravelPricingAgeFilter(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_AGE_FILTER_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingAgeFilterInput) {
    forceDeleteTravelPricingAgeFilter(input: $input) {
      success
    }
  }`
// language=GraphQL
export const AGE_FILTERS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricingRules: Boolean = false) {
  groupedDependents: travelPricingAgeFilterDependents(id: $id) {
    travelPricingRules @include(if: $withTravelPricingRules) {
      id
      checkAccommodationTypes
      checkAccommodationAddons
      checkAgeGroups
      useAgeFilter
      checkDateRange
      startDate
      endDate
      checkTravelDate
    }
  }
}`
